module.exports = __webpack_public_path__ + "static/img/resources-banner.bfb01cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/resources-banner.jpg
// module id = 1b5Z
// module chunks = 1